import React from 'react';
import { AppDialog } from './AppDialog';
import { DesktopIcon } from './Icons';

interface DesktopOnlyNoticeProps {
  open: boolean;
  onClose: () => void;
  title?: string;
  subtitle?: string;
}

export const DesktopOnlyNotice: React.FC<DesktopOnlyNoticeProps> = ({
  open,
  onClose,
  title = 'Please switch to a larger screen',
  subtitle = 'The form editor needs more space than this screen offers. Please open this page on a desktop or tablet to create or edit forms.',
}) => (
  <AppDialog
    open={open}
    onClose={onClose}
    title={title}
    subtitle={subtitle}
    icon={<DesktopIcon />}
    actions={[{ label: 'Got it', onClick: onClose, variant: 'primary' }]}
  />
);

export default DesktopOnlyNotice;
